export default function FloatingWhatsApp() {
  return (
    <a
      href="https://wa.me/5585999372109?utm_source=site&utm_medium=floating_button&utm_content=agendar_consulta"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-[60] w-14 h-14 rounded-full flex items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110 hover:shadow-xl"
      style={{
        backgroundColor: '#25D366',
        boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)',
      }}
    >
      <i className="ri-whatsapp-line text-2xl" style={{ color: '#FFFFFF' }} />
      {/* Pulse ring */}
      <span
        className="absolute inset-0 rounded-full animate-ping"
        style={{
          backgroundColor: 'rgba(37, 211, 102, 0.3)',
          animationDuration: '2s',
        }}
      />
    </a>
  );
}